require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-basic-data-structures-use-an-array-to-store-a-collection-of-data.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-basic-data-structures-use-an-array-to-store-a-collection-of-data");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-basic-data-structures-use-an-array-to-store-a-collection-of-data!./.cache/json/javascript-algorithms-and-data-structures-basic-data-structures-use-an-array-to-store-a-collection-of-data.json
// module id = 2246
// module chunks = 231608221292675